const login = {
  userPlaceholder: "请输入用户名",
  userError: "请输入用户名",
  pwdPlaceholder: "请输入密码",
  pwdError: "请输入登录密码",
  login: "登录"
} 
export default login